import { MarkdownSwitcher } from './MarkdownSwitcher'

type Props = {
  content: string
  classes?: string
}

export const Markdown = ({ content, classes }: Props): JSX.Element => (
  <MarkdownSwitcher {...{ content, classes }} />
)
